/* src/app/private/layout/main/main.component.scss */
.content {
  transition: margin-left 0.3s ease;
}
.main-body {
  overflow-y: hidden;
}
/*# sourceMappingURL=main.component.css.map */
